import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaChevronDown, FaCircleQuestion, FaHandsPraying } from "react-icons/fa6";

const faqs = [
  {
    q: "What is the best time to visit Khajuraho?",
    a: "The best time to visit Khajuraho is from October to March when the weather is pleasant for exploring the temples. The Khajuraho Dance Festival in February is also a major attraction."
  },
  {
    q: "Are there any entry fees for the Western Group of Temples?",
    a: "Yes, there is an entry fee for the Western Group of Temples, which is a UNESCO World Heritage site. Fees differ for Indian citizens and international tourists."
  },
  {
    q: "Do you provide local guides for temple tours?",
    a: "Yes, we provide government-approved local guides who are experts in the history, architecture, and iconography of the Khajuraho Routess."
  },
  {
    q: "How many days are enough to see Khajuraho?",
    a: "Usually, 2 full days are enough to cover the Western, Eastern, and Southern groups of temples, along with the Raneh Falls and Panna National Park."
  },
  {
    q: "What are the nearby attractions from Khajuraho?",
    a: "Nearby attractions include Panna National Park (Safari), Raneh Falls (Mini Grand Canyon), Pandav Falls, and the historic town of Orchha."
  },
  {
    q: "Is Khajuraho safe for solo travelers?",
    a: "Absolutely. Khajuraho is a friendly tourist destination. We also provide dedicated support and transport to ensure a safe and comfortable experience for solo travelers."
  }
];

const HomeFaqs = () => {
  const [active, setActive] = useState(0);

  return (
    <section className="bg-white py-14 lg:py-24 relative overflow-hidden">
      {/* Decorative background blur */}
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-orange-main/5 rounded-full blur-[100px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          
          {/* LEFT SIDE: HEADER */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="sticky top-10"
          >
            <div className="flex items-center gap-2 mb-4">
              <div className="h-[2px] w-8 bg-orange-main" />
              <span className="text-[10px] font-black uppercase tracking-[0.2em] text-orange-main">Help Center</span>
            </div>
            
            <h2 className="text-4xl lg:text-5xl font-black text-gray-dark tracking-tighter leading-tight mb-6">
              Frequently Asked <br />
              <span className="text-orange-main">Yatra Questions</span>
            </h2>
            
            <p className="text-gray-500 text-base leading-relaxed mb-10 max-w-md font-medium">
              Find answers to common questions about your spiritual journey. We're here to make your yatra smooth and memorable.
            </p>

            {/* <div className="p-6 rounded-[2rem] bg-orange-main/5 border border-orange-main/10 inline-flex items-center gap-4">
               <div className="w-12 h-12 rounded-2xl bg-orange-main text-white flex items-center justify-center text-xl shadow-lg shadow-orange-main/20">
                  <FaHandsPraying />
               </div>
               <div>
                  <p className="text-sm font-bold text-gray-dark leading-none mb-1">Need more help?</p>
                  <p className="text-xs text-gray-500 font-medium">Our experts are a click away</p>
               </div>
            </div> */}
          </motion.div>

          {/* RIGHT SIDE: ACCORDION (Orange Theme Borders) */}
          <div className="space-y-4">
            {faqs.map((item, i) => {
              const isOpen = active === i;

              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.05 }}
                  className={`rounded-[1.5rem] transition-all duration-500 overflow-hidden border-2 ${
                    isOpen 
                      ? "bg-white shadow-[0_20px_50px_rgba(194,74,26,0.1)] border-orange-main" 
                      : "bg-white border-orange-main/10 hover:border-orange-main/30 hover:shadow-lg"
                  }`}
                >
                  <button
                    onClick={() => setActive(isOpen ? null : i)}
                    className="w-full flex justify-between items-center text-left px-8 py-6 group focus:outline-none outline-none border-none"
                  >
                    <div className="flex items-center gap-4">
                      <div className={`w-2 h-2 rounded-full transition-all duration-500 ${isOpen ? "bg-orange-main scale-150" : "bg-gray-200"}`} />
                      <span className={`text-base font-bold tracking-tight transition-colors duration-500 ${isOpen ? "text-orange-main" : "text-gray-500"}`}>
                        {item.q}
                      </span>
                    </div>
                    <FaChevronDown className={`text-xs transition-transform duration-500 ${isOpen ? "rotate-180 text-orange-main" : "text-gray-400"}`} />
                  </button>

                  <AnimatePresence>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.4, ease: [0.04, 0.62, 0.23, 0.98] }}
                      >
                        <div className="px-8 pb-8 pl-[3.5rem]">
                          <p className="text-gray-500 text-sm leading-relaxed font-medium">
                            {item.a}
                          </p>
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              );
            })}
          </div>

        </div>
      </div>
    </section>
  );
};

export default HomeFaqs;
